import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  paper: {
    padding: '0 0 25px',
    width: '920px'
  },
  titleContainer: {
    color: 'rgb(255, 255, 255)',
    height: '80px',
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: 'rgb(48, 50, 107)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: '21px',
    textAlign: 'center',
    textTransform: 'capitalize'
  },
  subtitle: {
    color: 'rgb(0, 10, 18)',
    fontSize: '19px',
    fontWeight: 400,
    letterSpacing: '0.09px',
    lineHeight: '17px',
    textAlign: 'center',
    padding: '30px 0px',
    marginTop: 0,
    marginBottom: '1rem'
  },
  questionsContainer: {
    padding: '0 35px'
  },
  questionsLabel: {
    fontSize: '16px',
    transform: 'translate(0px, -8px)',
    transformOrigin: 'left top',
    color: 'rgb(69, 18, 149)',
    transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms'
  },
  gpaContainer: {
    marginTop: '15px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 35px'
  },
  withdrawButtonContainer: {
    width: '920px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  withdrawButton: {
    backgroundColor: 'red',
    color: '#fff',
    padding: '10px 15px',
    '&:hover': {
      color: 'red'
    }
  }
}))
